module.exports = __webpack_public_path__ + "static/logo-9fea24c56590525b0ca6d9c57dfc8450.svg";